import React from 'react';
import BillLines from '../BillLines';
import { formatMoney, paidTotal } from '../../../utils/money';

/** Step 6 — approve locks the bill and generates the invoice number. */
export default function ApproveStep({ bill }) {
  return (
    <div className="dp-step-body">
      <div className="dp-step-head">
        <h2>Approve</h2>
        <p className="dp-help">
          Manager <strong>{bill.manager_name || '—'}</strong> confirmed the payment. Approving locks the bill and creates the invoice.
        </p>
      </div>
      <div className="dp-pay-totals">
        <div>
          <span>Grand total</span>
          <strong>{formatMoney(bill.grand_total)}</strong>
        </div>
        <div>
          <span>Paid</span>
          <strong>{formatMoney(paidTotal(bill))}</strong>
        </div>
        <div>
          <span>Branch</span>
          <strong>{bill.franchise_name || '—'}</strong>
        </div>
      </div>
      <BillLines bill={bill} />
    </div>
  );
}
